//==============notificationCtrl controller==================
'use strict';
App.controller('notificationCtrl',['$scope','$http','$location','ngDialog','$state','$timeout','$stateParams','Api',
    '$loading','authApi','toastr', 'userService', '$localStorage',
    function ($scope,$http,$location,ngDialog,$state,$timeout,$stateParams,Api,$loading,authApi,toastr, userService, $localStorage) {
    $scope.notificationCount=1;
    $scope.skip = 0;
    $scope.pagination = {
        currentPage: 1,
        maxSize: 5,
        limitPerPage:10
    };
    $scope.getNotification = function (skip,pagination) {
        $loading.start('notification');
        userService.listNotifications($localStorage['token'], {
            markAsRead: true,
            skip,
            limit: $scope.pagination.limitPerPage
        }).then(({list, count}) => {
            $scope.$emit('updateNotifications');
            $loading.finish('notification');
            $scope.notification = list;
            $scope.notificationCount = count;
            $scope.$apply();
        });
    };
    $scope.getNotification($scope.skip,false);
    
    $scope.pageChanged = function(currentPage){
      if(currentPage != 0){
        $scope.skip = (currentPage -1) * $scope.pagination.limitPerPage;
        $scope.getNotification($scope.skip,true);
      } else {
        $scope.skip = 0;
        $scope.getNotification($scope.skip,true);
      }
    }


}]);